const messages = {
    'zh-Hant': {
        welcomeBack: '歡迎回來',
        email: '電郵',
        password: '密碼',
        signin: '登入',
        regEmailMessage: '請輸入有效電郵',
        enterEmail: '電郵不能為空白',
        enterPassword: '密碼不能為空白',
        regPasswordLengthMessage: '^密碼最少4位',
        regUsernamePresenceMessage: '^用戶名稱不能為空白',
        regRetypePasswordMessage: '^確認密碼不正確',
        staffOnly: '只限店鋪管理員登入',
        confirm: '確定',
        memberId: '會員編號',
        memberCategory: '會員等級',
        MemberList: '會員管理',
        MemberDetail: '會員詳情',
        joinDate: '於{{createdAt}}加入',
        memberCredit: '{{credit}}積分',
        MemberOrderList: '查看訂單及預約',
        NotificationList: '通知',
        OrderList: '訂單及預約',
        orderCreatedAt: '訂單日期: {{date}}',
        orderNumber: '訂單編號: {{orderId}}',
        orders: '購物訂單',
        qrScan: '掃描QR',
        orderSummary: '{{totalProducts}} 件貨品 {{totalReservations}} 項預約 合計 HK$ {{price}}',
        orderQuantity: '{{quantity}} 件',
        orderTotal: '合計 HK$ {{amount}}',
        orderDiscount: '(已包HK$ {{discount}} 折扣)',
        name: '名稱',
        contactNumber: '電話號碼',
        EditCredit: '修改積分',
        creditErrorMessage: '積分必需為大於0的數字',
        OrderDetail: '訂單詳情',
        deliveryMethod: '取貨方式',
        store: '店鋪',
        reservationOrders: '預約訂單',
        UserCouponDetail: '優惠券',
        PospalUser: '店鋪會員',
        EditPospalUser: '更改店鋪會員資料',
        editPospalUserSuccess: '更改店鋪會員成功',
        CreatePospalUser: '新增店鋪會員',
        createPospalUserSuccess: '新增店鋪會員成功',
        noSuchPospalUser: '沒有相關店鋪會員資料...',
        LinkPospalUser: '連結店鋪會員',
        username: '會員名稱',
        pleaseEnterUsername: '請輸入會員名稱',
        phoneNumber: '電話號碼',
        pleaseEnterPhoneNumber: '請輸入電話號碼',
        email: '電郵地址',
        pleaseEnterEmail: '請輸入電郵地址',
        memberCategory: '會員等級',
        pleaseSelectMemberCategory: '請選擇會員等級',
        pospalDiscount: '優惠折扣%',
        pleaseEnterPospalDiscount: '請輸入優惠折扣',
        noContent: '找不到相關',
        useCoupon: '使用優惠券',
        minPriceRequired: '最低使用金額: HK$ {{minPriceRequired}}',
        maxPurchase: '每人最多兌換: {{maxPurchase}}張',
        discount: '折扣金額: HK$ {{discount}}',
        userCouponDetail: '優惠券詳情',
        dateExpired: '{{date}}到期',
        TnC: '條款細則',
        couponIntro: '優惠簡介',
        usedAlready: '已使用',
        redeemSuccess: '使用優惠券成功',
        expired: '到期',
        option: '選項',
        address: '地址',
        quantity: '數量',
        reservationTime: '預約時間',
        SFEXPRESS: '順豐速遞',
        CONTACT_SELLER: '自行聯絡賣家',
        SELF_PICK_UP: '店鋪自取',
        PENDING: '等待確認',
        CONFIRMED: '已確認',
        COMPLETE: '已完成',
        ReservationList: '預約管理',
        minus: '減堂',
        minusLesson: '扣減一堂',
        TopUp: '增值',
        count: '次數',
        success: '成功',
        topUpSuccess: '增值成功',
        countMessage: '^次數需要整數及大過0',
        Feed: '動態管理',
        EditCredit: '修改積分',
        MemberCreditList: '積分紀錄',
        ReservationList: '預約列表',
        CreditList: '積分紀錄',
        FeedList: '動態列表',
        credit: '積分',
        ORDER: '消費',
        TOP_UP: '增值',
        DAILY_BONUS: '登入積分',
        REDEEM: '換領',
        BAOFOOD: '餐廳',
        date: '日期: {{date}}',
        CreateFeed: '新增動態',
        inputTitle: '輸入標題',
        inputContent: '輸入內容',
        chooseFromAlbum: '從相簿選擇',
        uploadFromCamera: '拍照上傳',
        billPrice: '賬單價錢',
        enterBillPrice: '輸入賬單價錢',
        remark: '備注(如需要)',
        creditNow: '現在積分',
        creditAfter: '增加積分後',
        cancel: '取消',
        edit: '修改',
        delete: '刪除',
        uploadMethod: '上載方式',
        createFeedSuccess: '新增動態成功',
        editFeedSuccess: '修改動態成功',
        FeedDetail: '動態詳情',
        EditFeed: '修改動態',
        pleaseSelect: '請選擇',
        search: '搜尋',
        NORMAL: '一般',
        GOLD: '特選',
        STUDENT: '學生',
        ONE_TO_ONE: '一對一',
        PERIOD: '普通',
        UNLIMITED: '無限',
        ACTIVE: '正常',
        INACTIVE: '禁用',
        DELETED: '刪除',
        20001: '電話號碼錯誤',
        1005: '密碼錯誤',
        1006: '登入失敗',
        1007: '電郵錯誤',
        14000: '新增店鋪會員失敗',
        31000: '只限員工登入',
        31001: '增加積分失敗'
    }
}

export default messages